import axios, { AxiosError } from "axios";
import { env } from "@/env";
import { store } from "@/store";
import { router } from "@/router";
import { TelemetryService } from "@/services/TelemetryService";

const apiClient = axios.create({
    baseURL: `${env.api.origin}${env.api.apiPath}`,
    responseType: "json",
});

apiClient.interceptors.request.use(async (requestConfig) => {
    const token = await store.dispatch("user/getAccessToken");

    // Add Authorization header to the requests
    if (token != null) {
        requestConfig.headers.Authorization = `Bearer ${token}`;
    }

    return Promise.resolve(requestConfig);
});

apiClient.interceptors.response.use(null, async (error: AxiosError) => {
    // Map to JavaScript error for App Insights
    const jsError = mapToError(error);

    // Log request error
    TelemetryService.logError(jsError, { url: error.config.url });

    // If the user is unauthenticated, redirect to login
    if (error.response.status === 401) {
        await store.dispatch("user/getAccessToken");
        router.push("/");
    }

    return Promise.reject(error);
});

function mapToError(axiosError: AxiosError) {
    const error = new Error(axiosError.message);
    error.name = "API request error";
    error.stack = axiosError.stack;

    return error;
}

export { apiClient };
